export const readAllDirEntries = async (fsClient, key) => {
    const entries = [];
    const dirIterator = fsClient.fileSystem().readDir(key);
    let next = await dirIterator.next();
    while (!next.done) {
        entries.push(next.value);
        next = await dirIterator.next();
    }
    return entries;
};
